import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ChartAccountService } from '../chart-account.service';
import { ChartAccount } from '../chart-account';
import { ChartAccountComponent } from '../chart-account/chart-account.component';

@Component({
    selector: 'app-chart-account-list',
    templateUrl: './chart-account-list.component.html',
    styleUrls: ['./chart-account-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ChartAccountListComponent implements OnInit {
	constructor(
		private chartAccountService: ChartAccountService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = chartAccountService.statuses
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	chartAccounts: any;
	chartAccount: ChartAccount;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'chartAccountId', header: 'Id', width: 'auto' },
		{ field: 'actType', header: 'Act Type', width: 'auto' },
		{ field: 'actCode', header: 'Act Code', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },


	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.chartAccountId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-chartAccount-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.chartAccountService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.chartAccounts = res.data.chartAccounts;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.chartAccounts = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(chartAccount: ChartAccount) {
		try {
			this.formLoading = true;
			this.chartAccountService.update(chartAccount)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.chartAccounts.map((chartAccount, i) => {
							if (chartAccount.chartAccountId === res.data.chartAccount.chartAccountId) {
								this.chartAccounts[i] = res.data.chartAccount;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(chartAccount: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(chartAccount));

			this.formLoading = true;
			this.chartAccountService.delete(chartAccount.chartAccountId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.chartAccounts.splice(this.chartAccounts.indexOf(chartAccount), 1);
						this.recordTotal = this.chartAccounts.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ChartAccount ' + chartAccount.chartAccountId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ChartAccount ' + chartAccount.chartAccountId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add ChartAccount'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ChartAccountComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addChartAccountCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(chartAccount: ChartAccount) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			chartAccount: chartAccount,
			title: 'Edit ChartAccount'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ChartAccountComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateChartAccountCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteChartAccountCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addChartAccountCB(chartAccount: ChartAccount) {
		console.log('Adding ChartAccount: ' + JSON.stringify(chartAccount));
		// if we don't have a chartAccounts array yet...
		if (!this.chartAccounts) {
			this.chartAccounts = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.chartAccounts.unshift(chartAccount);

		// no idea what this is but it is required to update the array
		this.chartAccounts = [...this.chartAccounts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ChartAccount ' + chartAccount.chartAccountId + ' Added', life: 3000 });
	}

	updateChartAccountCB(chartAccount: ChartAccount) {
		console.log('Updating ChartAccount: ' + JSON.stringify(chartAccount));
		let itemIndex = this.chartAccounts.findIndex((item: any) => item.chartAccountId === chartAccount.chartAccountId);
		this.chartAccounts[itemIndex] = chartAccount;

		// no idea what this is but it is required to update the array
		this.chartAccounts = [...this.chartAccounts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ChartAccount ' + chartAccount.chartAccountId + ' Updated', life: 3000 });
	}

	deleteChartAccountCB(chartAccount: ChartAccount) {
		console.log('Removing ChartAccount: ' + chartAccount);
		this.chartAccounts.splice(this.chartAccounts.indexOf(chartAccount), 1);
		this.recordTotal = this.chartAccounts.length;

		// no idea what this is but it is required to update the array
		this.chartAccounts = [...this.chartAccounts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ChartAccount ' + chartAccount.chartAccountId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.chartAccounts ? this.first === (this.chartAccounts.length - this.rows) : true; }
	isFirstPage(): boolean { return this.chartAccounts ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(chartAccount: any) {
		if (chartAccount?.status) {
			const status = this.statuses.find((e: any) => e.value == chartAccount.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}
}
